import React, { Component } from 'react';
import { Button, Form, FormGroup, Modal, Row, Col, Container } from 'react-bootstrap';
import { Snackbar } from '@mui/material';
import { IconButton } from '@mui/material';




import SessionFormationService from '../services/SessionFormationService';
import DossierService from "../services/DossierService";
import AuthService from "../services/LoginService";
import StudentService from "../services/StudentService";
import EventBus from "../common/EventBus";


export class AddDossier extends Component {


    emptyItem = {
        sessionId: 0,
        sessionName: "",
        formationName: "",
        status: "",
        entreprise: "",
        createdAt: "",
        studentName: "",
        payMode: "",
        studentId: 0,
        payModeList: [],
        student: {
            id: 1,
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            address: "",
            zipCode: "",
            city: "",
            country: ""
        }
    };


    constructor(props) {
        super(props);
        this.state = {
            item: this.emptyItem,
            //formationId: '',
            dossiers: [],
            sessions: [],
            students: [],
            snackbaropen: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.retrieveDossiers = this.retrieveDossiers.bind(this);
        this.handleStudentChange = this.handleStudentChange.bind(this);
        this.handleSessionChange = this.handleSessionChange.bind(this);
        this.handleStudentIdChange = this.handleStudentIdChange.bind(this);
        this.handleSessionNameChange = this.handleSessionNameChange.bind(this);
    }

   
/*    componentDidMount() {
        const currentUser = AuthService.getCurrentUser();
        if (!currentUser) {
            this.setState({ redirect: "/login" });
        } else {
            this.retrieveDossiers();
            this.retrieveSessions();
            //this.searchStudent() ;
        }
    }
*/
   


    componentDidUpdate(previousProps, currentState) {
        //console.log('In add Dossier componentDidUpdate:::');
        //console.log(this.props.currentdossier);
        // console.log('previous');
        // console.log(previousProps.currentdossier);
        if (previousProps.currentdossier !== this.props.currentdossier) {
            // console.log('is diff :::');
            this.setState({ item: this.props.currentdossier });
        }
    }

    retrieveDossiers() {
        //const { firstNameFilter, lastNameFilter, page, pageSize } = this.state;
        //const params = this.getRequestParams(firstNameFilter, lastNameFilter, page, pageSize);
        DossierService.getAll()
            .then((response) => {
                const { dossiers } = response.data;

                this.setState({
                    dossiers: dossiers,
                });
                //console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            });

    }

    /* retrieveSessions() {
         SessionFormationService.getAll().then((response) => {
             const { sessions } = response.data;
 
             this.setState({
                 sessions: sessions,
             });
             //console.log(response.data);
         })
             .catch((error) => {
                 console.log(error);
                 if (error.response && error.response.status === 401) {
                     EventBus.dispatch("logout");
                 }
             });
 
     }
     */

    retrieveSessions() {
        let params = {};
        params["minSessionDate"] = '2020-01-01';
        params["maxSessionDate"] = '2050-01-01';
        SessionFormationService.getAll(params).then((response) => {
            const { sessions } = response.data;

            this.setState({
                sessions: sessions,
            });
            //console.log(response.data);

        })
            .catch((error) => {
                console.log(error);
                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            });

    }



    searchStudent() {
        console.log(this.state.item);
        let studentName = this.state.item.student.lastName;
        console.log('student Name in search : ' + studentName);
        if (studentName) {
            StudentService.getByLastName(studentName).then((response) => {
                const { students } = response.data;

                this.setState({
                    students: students,
                });
                console.log(response.data);
            })
                .catch((error) => {
                    console.log(error);
                    if (error.response && error.response.status === 401) {
                        EventBus.dispatch("logout");
                    }
                });
        }

    }


    searchSession() {
        console.log(this.state.item);
        let sessionName = this.state.item.sessionName;
        console.log('sessionName Name in search : ' + sessionName);
        if (sessionName) {
            let params = {};
            params["minSessionDate"] = '2020-01-01';
            params["maxSessionDate"] = '2050-01-01';
            params["sessionName"] = sessionName;
            SessionFormationService.getAll(params).then((response) => {
                const { sessions } = response.data;

                this.setState({
                    sessions: sessions,
                });
                //console.log(response.data);

            })
                .catch((error) => {
                    console.log(error);
                    if (error.response && error.response.status === 401) {
                        EventBus.dispatch("logout");
                    }
                });
        }

    }



    handleChange(event) {
        //console.log('In add session handleChange :::');
        //console.log(event);
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = { ...this.state.item };


        if (name === "formationId") {
            // let formationId = { ...this.state.formationId };
            //formationId = value;
            item.formation['id'] = value;
        } else {
            item[name] = value;
        }
        this.setState({ item });

        //console.log('State after change');
        // console.log(item);
    }



    handleSessionChange(event) {
        //console.log('In add session handleSessionChange :::');
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = { ...this.state.item };

        item[name] = value;
        item.payModeList = [];
        SessionFormationService.getPaimentsMode(value).then((response) => {
            //console.log('liste paimenets ...');
            //console.log(response.data);

            response.data.forEach(val => {
                //console.log('inserting value  : '+val);
                item.payModeList.push(val);
            });
            this.setState({ item });
        }).catch((error) => {
            console.log(error);
            if (error.response && error.response.status === 401) {
                EventBus.dispatch("logout");
            }
        });
    }


    handleStudentChange(event) {
        console.log('In add session handleStudentChange :::');
        console.log(event);
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = { ...this.state.item };
        item.student[name] = value;
        this.setState({ item });

        //console.log('State after change');
        // console.log(item);
    }

    
    handleSessionNameChange(event) {
        console.log('In add session handleSessionNameChange :::');
        console.log(event);
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = { ...this.state.item };
        item.sessionName = value;
        this.setState({ item });

        //console.log('State after change');
        console.log(item);
    }

    handleStudentIdChange(event) {
        console.log('In add session handleStudentIDChange :::');
        console.log(event);
        const target = event.target;
        const value = target.value;
        // const name = target.name;
        let item = { ...this.state.item };
        item.student['id'] = value;
        this.setState({ item });

        //console.log('State after change');
        // console.log(item);
    }


    handleSubmit(event) {
        event.preventDefault();
        const { refreshParentDossier,  ...rest } = this.props;
        const { item } = this.state;
        if (item.id) {
            DossierService.update(item.id, event)
                .then((response) => {
                    const { message } = response.data;
                    //alert(message)
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                    refreshParentDossier(item);
                    this.props.onHide();
                })
                .catch((err) => {
                    console.log(err);
                    const { message } = err.response.data;
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                });
        } else {
            DossierService.create(event)
                .then((response) => {
                    const { message } = response.data;
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                    refreshParentDossier(item);
                    this.props.onHide();
                })
                .catch((err) => {
                    console.log(err);
                    const { message } = err.response.data;
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                });
        }

    }

    onChangeStartDate(e) {
        const startDateVal = e.target.value;
        console.log(startDateVal);
        //Moment.locale('en');        
        this.setState({
            startDateFilter: startDateVal,
        });
    }
    onChangeEndDate(e) {
        const endDateVal = e.target.value;
        //Moment.locale('fr');
        console.log(endDateVal);
        this.setState({
            endDateFilter: endDateVal,
        });
    }


    snackbarClose = (event) => {
        this.setState({ snackbaropen: false });
    }

    render() {
        const { item, sessions, students } = this.state;
        //console.log('In render : ');
        //console.log(item);
        const titre = <h2>{item.id ? 'Modifier Dossier' : 'Ajout Dossier'}</h2>;

        const studentsList = students.map(student => {
            //console.log('student id = ' + student.id);
            return <option key={student.id} value={student.id}>{student.lastName}-{student.firstName}-{student.address}</option>
        });


        const sessionList = sessions.map(session => {
            return <option key={session.id} value={session.id}>{session.name}</option>
        });



        //{formationList}
        // { dossiers.map(formation => <option value={formation.id}>{formation.id}-{formation.name}-{formation.payMode}</option>)}

        return (
            <div className='container'>

                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    open={this.state.snackbaropen}
                    autoHideDuration={3000}
                    onClose={this.snackbarClose}
                    message={<span id='message-id'> {this.state.snackbarmsg}  </span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label='Close'
                            color='inherit'
                            onClick={this.snackbarClose}
                        >X</IconButton>
                    ]}
                ></Snackbar>

                <Modal
                    {...this.props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {titre}
                        </Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={this.handleSubmit}>
                        <Modal.Body>
                            <Container>

                                <Row>
                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='sessName'>
                                            <Form.Label>Nom Session</Form.Label>
                                            <Form.Control size="sm" type="text" name='sessionName' onChange={this.handleSessionNameChange} value={item.sessionName || ''} placeholder='Nom de session' />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={6} md={6}>
                                        <FormGroup>
                                            <Form.Label>Chercer une Session par son nom</Form.Label>
                                            <Button size="sm" variant="secondary" onClick={() => this.searchSession()} >Chercher</Button>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12}>
                                        <FormGroup controlId='sessionId'>
                                            <Form.Label>Session</Form.Label>
                                            <Form.Select size="sm" aria-label="Session" name='sessionId' onChange={this.handleSessionChange} value={item.sessionId || ''} required>
                                                <option>Choisir une session</option>
                                                {sessionList}
                                            </Form.Select>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='lastName'>
                                            <Form.Label>Nom</Form.Label>
                                            <Form.Control size="sm" type="text" name='lastName' onChange={this.handleStudentChange} value={item.student.lastName || ''} placeholder='Nom stagiaire' />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={6} md={6}>
                                        <FormGroup>
                                            <Form.Label>Chercer un Stagiaire par son nom</Form.Label>
                                            <Button size="sm" variant="secondary" onClick={() => this.searchStudent()} >Chercher</Button>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12}>
                                        <FormGroup controlId='studentId'>
                                            <Form.Label>Stagiaire</Form.Label>
                                            <Form.Select size="sm" aria-label="Stagiare" name='studentId' onChange={this.handleStudentIdChange} value={item.student.id || item.studentId} required>
                                                <option value={item.studentId}>slectionner un stagiaire</option>
                                                {studentsList}
                                            </Form.Select>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='g'>
                                            <Form.Label>Mode Paiement</Form.Label>
                                            <Form.Select size="sm" aria-label="Mode Paiement" name='payMode' onChange={this.handleChange} value={item.payMode || ''} required>
                                                <option>Choisir une methode de paiement</option>
                                                 {this.state.item.payModeList.map((mode, index) => (
                                                    <option key={index} value={mode}>{mode}</option>
                                                ))}
                                            </Form.Select>
                                        </FormGroup>

                                    </Col>
                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='status'>
                                            <Form.Label>Status</Form.Label>
                                            <Form.Select size="sm" aria-label="Mode Paiement" name='status' onChange={this.handleChange} value={item.status || 'En Attente'} required>
                                                <option>Choisir Etat</option>
                                                <option value="En Attente">En Attente</option>
                                                <option value="En Cours">En Cours</option>
                                                <option value="Validé">Validé</option>
                                                <option value="Terminé">Terminé</option>
                                                <option value="Facturé">Facturé</option>
                                                <option value="Autre">Autre</option>
                                            </Form.Select>
                                        </FormGroup>
                                        <FormGroup controlId='id'>
                                            <Form.Control type="hidden" name='id' onChange={this.handleChange} value={item.id || ''} />
                                        </FormGroup>
                                    </Col>

                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='formateur'>
                                            <Form.Label>Formateur</Form.Label>
                                            <Form.Control size="sm" type="text" name='formateur' onChange={this.handleChange} value={item.formateur || ''} placeholder='Formateur' />
                                        </FormGroup>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col xs={12} md={12}>
                                        <FormGroup controlId='price'>
                                            <Form.Label>Prix Formation ( en modification seulement)</Form.Label>
                                            <Form.Control size="sm" disabled={item.id ? false : true} type="text" name='price' onChange={this.handleChange} value={item.price || ''} placeholder='Prix formation' />
                                        </FormGroup>
                                    </Col>
                                </Row>                   


                            </Container>


                        </Modal.Body>
                        <Modal.Footer>
                            <FormGroup>
                                <Button variant="dark" type="submit" >Enregistrer</Button>
                            </FormGroup>
                            <Button variant='danger' onClick={this.props.onHide}>Fermer</Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </div>
        );
    }
}